<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
	<mat-error class="top-right-absolute-error-message">{{ 'mes.administration.worktasks.dialog.duplicate-error' | translate }}</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">{{ (isEdit ? 'mes.administration.worktasks.dialog.edit-worktask' : 'mes.administration.worktasks.dialog.create-worktask') | translate }}</h1>

	<mat-dialog-content style="padding-top: 20px">
		@if (controls['alias'].invalid && (controls['alias'].touched || isEdit)) {
		<mat-error>{{ 'mes.administration.worktasks.dialog.alias.error.' + getFirstValidationErrorName('alias') | translate }}</mat-error>
		}
		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'mes.administration.worktasks.dialog.alias.label' | translate }}</mat-label>
			<input maxlength="255" matInput formControlName="alias" />
		</mat-form-field>

		@if (controls['name'].invalid && (controls['name'].touched || isEdit)) {
		<mat-error>{{ 'mes.administration.worktasks.dialog.name.error.' + getFirstValidationErrorName('name') | translate }}</mat-error>
		}
		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'mes.administration.worktasks.dialog.name.label' | translate }}</mat-label>
			<input maxlength="255" matInput formControlName="name" />
		</mat-form-field>

		@if (controls['salarytype'].invalid && (controls['salarytype'].touched || isEdit)) {
		<mat-error>{{ 'mes.administration.worktasks.dialog.tags.salarytype.error.' + getFirstValidationErrorName('salarytype') | translate }}</mat-error>
		}
		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'mes.administration.worktasks.dialog.tags.salarytype.label' | translate }}</mat-label>
			<input maxlength="255" matInput formControlName="salarytype" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			@if (controls['terminal'].invalid && (controls['terminal'].touched || isEdit)) {
			<mat-error>{{ 'mes.administration.worktasks.dialog.tags.terminal.error.' + getFirstValidationErrorName('terminal') | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'mes.administration.worktasks.dialog.tags.terminal.label' | translate }}</mat-label>
			<mat-select formControlName="terminal">
				@for (terminal of terminals; track terminal) {
				<mat-option [value]="terminal.alias">{{ terminal.alias }} - {{ terminal.name }}</mat-option>
				}
			</mat-select>
		</mat-form-field>

		@if (worktask.id != offstampId) {
		<div>
			@if (controls['categoryName'].invalid && (controls['categoryName'].touched || isEdit)) {
			<mat-error>{{ 'mes.administration.worktasks.dialog.tags.category-name.error.' + getFirstValidationErrorName('categoryName') | translate }}</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'mes.administration.worktasks.dialog.tags.category-name.label' | translate }}</mat-label>
				<input type="text" maxlength="255" placeholder="{{ 'mes.administration.worktasks.dialog.tags.category-name.placeholder' | translate }}" matInput [formControl]="categoryControl" formControlName="categoryName" [matAutocomplete]="auto" />
				<mat-autocomplete #auto="matAutocomplete">
					@for (option of categoryFilteredOptions | async; track option) {
					<mat-option [value]="option">{{displayCategoryOptions(option)}}</mat-option>
					}
				</mat-autocomplete>
			</mat-form-field>
		</div>
		} @if (worktask.id != offstampId) {
		<div>
			<mat-label class="mat-body-1">{{'mes.administration.worktasks.dialog.active.label' | translate}}</mat-label>
			<mat-checkbox formControlName="isActive" />
		</div>
		}
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid" [ngClass]="{ 'disabled-button': loading }">{{ 'general.ok' | translate }}</button>
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'general.cancel' | translate }}</button>
	</mat-dialog-actions>
</form>
